import { ToolHandler, ToolApplyContext } from '../tool-handler.interface'
import { ToolConfig, SetupGuideAiMessage, ArticleContentResult } from '../../types/ai-chat.types'

export class ArticleContentHandler implements ToolHandler {
  name = 'get_article_content'
  config: ToolConfig = {
    labelKey: 'SETUP_GUIDE.AI_CHAT.TOOL.GET_ARTICLE_CONTENT.LABEL',
    generatingKey: 'SETUP_GUIDE.AI_CHAT.TOOL.GET_ARTICLE_CONTENT.GENERATING',
    resultKey: 'SETUP_GUIDE.AI_CHAT.TOOL.GET_ARTICLE_CONTENT.RESULT',
    displayType: 'article-content',
    dashboardPage: 'general',
  }

  private readonly maxSnippetLength = 300

  getPreviewData(message: SetupGuideAiMessage): { snippet: string; url: string; title: string } {
    if (!message.toolContent) {
      return { snippet: '', url: '', title: '' }
    }

    const result = message.toolContent as unknown as ArticleContentResult
    const content = result.content ?? ''
    const snippet =
      content.length <= this.maxSnippetLength ? content : content.slice(0, this.maxSnippetLength).trimEnd() + '...'

    return {
      snippet,
      url: result.url ?? '',
      title: result.title ?? '',
    }
  }

  canApply(_message: SetupGuideAiMessage): boolean {
    return false
  }

  apply(_message: SetupGuideAiMessage, _context: ToolApplyContext): void {}
}
